import { DownloadDocumentButton } from '@/components/DownloadDocumentButton/DownloadDocumentButton'
import type { CSSProperties } from 'react'
import './Core.css'
import { ErrorIcon } from '@/components/SignDocumentCore/ErrorIcon'

interface ErrorContainerProps {
  height?: string | number
  width?: string | number
  documentUrl?: string
  setAllowSigning?: (allow: boolean) => void
  failedToLoadPdf: string
}

export const PdfErrorContainer: React.FC<ErrorContainerProps> = ({
  width,
  height,
  documentUrl,
  failedToLoadPdf,
  setAllowSigning,
}) => {
  return (
    <div
      className="pdf-core__viewer-container"
      style={
        {
          '--vc-width': typeof width === 'number' ? `${width}px` : width,
          '--vc-height': typeof height === 'number' ? `${height}px` : height,
        } as CSSProperties
      }
    >
      <div className="pdf-core__error-container">
        <ErrorIcon
          fillColor={'var(--icon-custom-color, var(--icon-main-color))'}
          backgroundColor="white"
        />

        <div className="pdf-core__error-title">{failedToLoadPdf}</div>

        {documentUrl && (
          <DownloadDocumentButton
            documentUrl={documentUrl}
            margin="0"
            onClick={() => setAllowSigning && setAllowSigning(true)}
          />
        )}
      </div>
    </div>
  )
}
